var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { isAndroidNative, isAndroidDevice, isIOSNative, isIOSDevice, isWX, isQQ, isMacNative, isPCNative, } from './platform';
import { sendMessage, checkMessage } from './index';
import { callIOS, evokeByTagA, joinParams } from './utils';
import { YINGYONGBAO_URL } from './config';
import clipboardCopy from './clipboard-copy';
/**
 * 支持手雷的统一 toast
 * @borrows 安卓和ios手雷
 * @param message toast 内容
 */
export function toast(message = '未知错误，请稍后再试') {
    if (isAndroidNative) {
        sendMessage({
            platform: 'android',
            name: 'xlShowToast',
            params: { message },
        }, { noCallback: true });
    }
    else if (isIOSNative) {
        sendMessage({
            platform: 'ios',
            name: 'toastMessage',
            params: { message },
        }, { noCallback: true });
    }
    else {
        // 先删除再添加
        const coverId = 'Y29tbW9udG9h';
        const preElement = document.getElementById(coverId);
        if (preElement) {
            preElement.remove();
        }
        const html = `<div style="
    position: fixed;
    left: 0;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    padding: 8px 16px;
    width: fit-content;
    max-width: 80%;
    font-size: 14px;
    color: #fff;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 6px;
    z-index: 99999;">${message}</div>`;
        const layerElement = document.createElement('div');
        layerElement.setAttribute('id', coverId);
        layerElement.innerHTML = html;
        document.body.appendChild(layerElement);
        const container = document.getElementById(coverId);
        // @ts-ignore
        let timerId = null;
        if (container) {
            timerId = setTimeout(() => {
                container.remove();
            }, 2000);
        }
    }
}
/**
 * 支持手雷的统一上报
 * @borrows 安卓和ios手雷
 * @param ct hubbleEventId or eventId
 * @param action hubbleAttribute1 or subEventId
 * @param extData 扩展 key value 对象值
 */
export function stat(ct, action, extData) {
    isAndroidNative &&
        sendMessage({
            platform: 'android',
            name: 'xlReportStatistics',
            params: {
                hubbleEventId: ct,
                hubbleAttribute1: action,
                hubbleExData: extData,
            },
        }, { noCallback: true });
    isIOSNative &&
        sendMessage({
            platform: 'ios',
            name: 'trackEvent',
            params: {
                eventId: ct,
                subEventId: action,
                extData,
            },
        }, { noCallback: true });
}
/**
 * 支持手雷的统一关闭页面
 */
export function close() {
    isAndroidNative &&
        sendMessage({ platform: 'android', name: 'xlFinishSelfActivity' }, { noCallback: true });
    isIOSNative &&
        sendMessage({ platform: 'ios', name: 'xlCloseView' }, { noCallback: true });
}
export function openPanFile(params) {
    if (!params.from) {
        params.from = 'web_yunpan';
    }
    // ios手雷内置浏览器无法用universalLink打开，所以采用jsBridge
    isIOSNative &&
        sendMessage({
            platform: 'ios',
            name: 'xunleiQuery',
            params: {
                target: 'cloud',
                action: 'openPage',
                params: Object.assign(Object.assign({}, params), { userId: params.user_id, fileId: params.file_id }),
            },
        }, { noCallback: true });
    !isIOSNative &&
        isIOSDevice &&
        callIOS({
            target: 'cloud',
            action: 'openPage',
            params: Object.assign(Object.assign({}, params), { fileId: params.file_id, userId: params.user_id }),
        });
    if (isAndroidDevice) {
        let android_url = joinParams('xunleiapp://xunlei.com/xlpan/open', params);
        if (isWX || isQQ) {
            // 微信、QQ内采用应用宝拉起手雷
            android_url =
                YINGYONGBAO_URL + '&android_schema=' + encodeURIComponent(android_url);
        }
        evokeByTagA(android_url);
    }
    // Mac云盘调用播放
    // isMacNative && sendMessage({ platform: 'mac', name: 'openCloudPlay', params: { gcid: params.gcid || '', fileId: params.file_id, medias: params.medias || [], fileName: '' }})
    // Mac浏览器的调用Mac云盘播放
    // if (isMacDevice && !isMacNative) {
    //   const url = `https://pan.xunlei.com?search=${JSON.stringify({ id: foldId, name: foldTitle })}`
    //   const MAC_PAN_URL = 'xunleiapp://mac.thunder/openTab?tabId=com.xunlei.plugin.page.cloudspace'
    //   const redirect = `${MAC_PAN_URL}&userId=${params.user_id}&jumpUrl=${encodeURIComponent(url)}`
    //   evokeByTagA(redirect)
    // }
    // PC浏览器调用PC迅雷播放
    // if (isPCBrowser || isPCNative) {
    //   const data = { opt: 'pan:location', params: { id: params.file_id, userid: params.user_id, needSync: true } }
    //   const url = `thunderx://${Base64.encode(JSON.stringify(data))}`
    //   evokeByIframe(url)
    // }
}
/**
 * 支持手雷的打开某个web URI
 * @param url web URL
 * @param title 标题
 * @param openType  1: 在业务浏览器打开新页面, 2: 系统浏览器打开, 3: 在手雷浏览器打开新页面。（已废弃）
 * @param mode  0：默认；1：全屏
 * @param from 来源，可用于埋点或其他用途
 * @param type external：手雷外部浏览器打开；internal：App Webview打开；search：带有搜索栏的Browser Webview打开
 */
export function openWebURL(params) {
    const { url, title = '', openType = 1, mode = 0, from = '', type = 'internal', } = params;
    if (isIOSNative) {
        if (type !== 'external') {
            const params = {
                url: encodeURIComponent(url),
                from,
            };
            if (type === 'internal') {
                // 需要同时设置 showFullScreen 和 hidebar参数
                params.showFullScreen = mode === 1 ? true : false;
                params.hidebar = mode === 1 ? true : false;
            }
            else {
                params.browserShowFrom = from; // 浏览器打开的来源，用于埋点（v1.5.4）
            }
            callIOS({
                target: 'hybrid',
                type: 'scheme',
                action: type === 'internal' ? 'openHybridWeb' : 'openFloatBrower',
                params,
                timeout: 2000,
                isClean: false,
                from,
                callback: () => { },
            });
        }
        else {
            // 打开Safari浏览器，并加载url
            sendMessage({
                platform: 'ios',
                name: 'openURL',
                params: {
                    url,
                    title,
                },
            }, { noCallback: true });
        }
    }
    else if (isAndroidNative) {
        if (type === 'search') {
            let queryStr = '';
            if (url) {
                queryStr += `url=${encodeURIComponent(url)}`;
            }
            if (title) {
                queryStr += `&title=${encodeURIComponent(title)}`;
            }
            if (from) {
                queryStr += `&from=${from}`;
            }
            window.location.href = `xunleiapp://xunlei.com/browser?${queryStr}`;
        }
        else {
            sendMessage({
                platform: 'android',
                name: 'xlOpenUrl',
                params: {
                    url,
                    title,
                    openType,
                    mode,
                    from,
                },
            }, { noCallback: true });
        }
    }
    else {
        window.location.href = url;
    }
}
/**
 * 支持手雷内拉起分享面板
 * @param title 分享标题
 * @param desc  分享描述
 * @param image 分享预览图
 * @param url 分享链接，url为空字符串，则为纯图分享
 * @param from 来源，可用于埋点或其他用途
 */
export function shareUrlToPlatform(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { title, desc, image, url, from = '' } = params;
        if (isAndroidNative) {
            const resp = yield sendMessage({
                platform: 'android',
                name: 'xlSocialShare',
                params: {
                    sharePlatform: 0,
                    shareHeadline: title,
                    shareText: desc,
                    shareImageUrl: image,
                    shareUrl: url,
                    shareType: !url ? 'ONLY_IMG' : '',
                    shareFrom: from,
                },
            }, { callbackTimeout: 1000 * 300 });
            return Promise.resolve(resp);
        }
        else if (isIOSNative) {
            // iOS v2.0.4及以上支持拉起分享面板，否则直接拉起微信
            const isFuncExist = yield checkMessage({
                platform: 'ios',
                name: 'xlCommonShare',
            });
            if (isFuncExist.exist === true) {
                const resp = yield sendMessage({
                    platform: 'ios',
                    name: 'xlCommonShare',
                    params: {
                        url: url,
                        title: title,
                        desc: desc,
                        image: image,
                        channel: '',
                        from: from,
                        shareType: !url && image ? 'image' : 'url',
                        unInstallText: '',
                    },
                }, { callbackTimeout: 1000 * 300 });
                return Promise.resolve(resp);
            }
            return location.assign(`xunlei://app/shareUrlToWechat?title=${title}&desc=${desc}&image=${image}&url=${url}&from=${from}`);
        }
        else if (isWX || isQQ) {
            const coverId = 'd2VjaGF0LXNoYX';
            const html = `<div style="position:fixed;top:0;left:0;right:0;bottom:0;margin:auto;z-index:999;background:rgba(0,0,0,.7);">
      <div style="display:flex;justify-content:center;flex-direction:column;position: relative;">
        <img style="width:80px;height:100px;position:absolute;top: 24px;right: 24px;z-index:1;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKAAAADIBAMAAACdRvcpAAAAIVBMVEUAAAD////////////////////////////////////////PIev5AAAACnRSTlMAEFmRKOl0sTzKOg4cNAAABANJREFUaN7lmrtv01AUxmPHTVImqwgomVooCDLxfngK4iHhiefiqQgY8MRrQJ6CKhDq1CKERCYa13X7/ZVwoybuwy04/g2WeqcoSn45557vnHtyrmvccmrwarsw0FtkeY4escCmBixwWQkLDKQeybMlvUVFI2mdBIaSYpBnySxQ2vUhEJS2PwSuccDI8EBpt4Y8UNrTQx4o7c42cIUSTWBooLQbQxoobevetzMdXb356zko7WPqMqAM6LLAtmoVB/oJDFzegoGdlAbGMNDboIEDGNingcE6DNQay7P0mwU6NLClFRZo6xILrNPApuZY4FR2Jh+VE2B5VLArW1+zcljV6jXuk6pabGz6r2Oj8qk8buYqm3mdUWdT2UTJdF3RM6+htyxwmpZhmz4Awm3VVLYaOnTrVaeD3KZP+TBheZbgmDTomLTpPPHgLXToLWzS7fUyrcIghUVDl39fi7DHyRHz2KI9rtMed2CPHcGqbusxG5K+unBINlmPQzgktuKiw9o77qGaKRQS52xfkp6+OsTApEDTtRSMh9M9wEArHLKeD6nJXGkDLc84u+D+ffXVM8SyBnak9PPYeSl1yxl4WtrY8eGTytOv9/8GOtLu/zHHpX1OnypgoK+t7t4tGOy/8VgtYODcvq/vfcsvkCQntPnP9+wid26eenl3Ou4uWRVokFq5n23vmgHcV4E6OK2V3LQY7Loyelegquf/uJf5bEWFOsIwPeB3FjMRJUUKf5T/6/b4L/FD6TIwMrc0GKfNJjIyD5ORAmMXAI6C5fRNXiK3BE0TFSfK8rJcUIyvK4aXBaScbExU1gzvxwQdpHvAXsSR9GmSEfelg4qG9HGidiA/KkuSrk02kcir7c71iXk1P2eC8CAo8WCEve/UnDHmxV8mBdY8DXZ+ddbg9N6dmri5rEvxwrhligwunTeVt1fmKYPkw9UbL28HMiu55ZYb3FrntGMlV9xtw4sDs6hGI9yHBXe0E+X639kz51/euJB1sBkQWjww28PKjueneWCPBU4dvadB8BuJsPKPRgSbLM/a0fRU8+oOv4U/RmeeT+s6TGFgMGB5Nq2aJh1kn66GXlZrqnlnUqcTz6ePvAjewhY9eZyib+48dWGP4fOkTd8SRXDTYOPP/MOVxlHisiGBa6sVwCI8Daed1YcLzQk4S5wANtCHRd0SbGAIh/iU1IUjsooa2FHMOgxHxJaeoTkXKXbZDUyorjqbLoPruFhJnxS7gbaUorxASQ/lsYqekfSCjAfMuwvzLrI8K5SSefAEiaS0R24fmh/Wa0lPON5MX9I1DOe8Gd7Gc7sXSPqOuTvrSdqaR73Ve5eK7dnRrJ9ZjWA064dW3XjL1vqf7ATKmq9Ve/0B2um5Yr6TnpsAAAAASUVORK5CYII=">
        <p style="color: #fff;font-size: 18px;text-align: center;font-weight: bold;line-height: 1.8;margin-top: 106px;">
          点击右上角<br/>分享给朋友或分享到朋友圈
        </p>
      </div>
    </div>`;
            const layerElement = document.createElement('div');
            layerElement.setAttribute('id', coverId);
            layerElement.innerHTML = html;
            document.body.appendChild(layerElement);
            const container = document.getElementById(coverId);
            if (container) {
                container.addEventListener('click', (e) => {
                    if (e.currentTarget == container) {
                        container.remove();
                    }
                }, false);
            }
        }
        else {
            try {
                yield clipboardCopy(url);
                toast('已复制链接到剪贴板中');
            }
            catch (err) {
                console.error('链接复制失败，请手动操作');
            }
        }
    });
}
export function payVip(params) {
    const { default_tab = 'supervip', default_pid = 'year', referfrom = '', aidfrom = '', payconfid = '', extra = {}, } = params;
    isAndroidNative &&
        sendMessage({
            platform: 'android',
            name: 'xlPay',
            params: {
                payType: 7,
                vasType: default_tab === 'supervip' ? 5 : 3,
                aidFrom: aidfrom,
                reportRefer: referfrom,
                payconfid,
                extra: Object.assign({ default_pid }, extra),
            },
        }, { noCallback: true });
    if (isIOSDevice) {
        const iosParams = {
            referfrom,
            aidfrom,
            selectedTab: default_tab,
            forYearProduct: default_pid === 'year',
        };
        const payAction = {
            target: 'user',
            action: 'vipPurchase',
            params: iosParams,
        };
        isIOSNative &&
            sendMessage({ platform: 'ios', name: 'xunleiQuery', params: payAction }, { noCallback: true });
        !isIOSNative && callIOS(payAction);
    }
    if (isMacNative) {
        sendMessage({
            platform: 'mac',
            name: 'showPaymentWindow',
            params: { referfrom, aidfrom, default_tab, default_pid },
        }, { noCallback: true });
    }
    if (isPCNative) {
        sendMessage({
            platform: 'pc',
            name: 'OpenPayVipUrl',
            params: `https://pay.xunlei.com/pages/2020/web-pay-center/?default_tab=${default_tab}&default_pid=${default_pid}&referfrom=${referfrom}&aidfrom=${aidfrom}`,
        }, { noCallback: true });
    }
}
/**
 * 支持标准浏览器、安卓手雷、IOS端、Mac迅雷和PC迅雷11的暗黑模式判断
 * @return Promise<boolean>
 */
export function isDark() {
    return __awaiter(this, void 0, void 0, function* () {
        if (isIOSNative) {
            const [_, res] = yield sendMessage({
                platform: 'ios',
                name: 'xlGetAppSkinId',
            });
            return res && res.skinId === 1;
        }
        if (isAndroidNative) {
            const res = yield sendMessage({
                platform: 'android',
                name: 'xlGetAppMetaData',
            });
            return res && res.darkMode;
        }
        if (isMacNative) {
            const [_, res] = yield sendMessage({
                platform: 'mac',
                name: 'getPlatformInfo',
                params: { keys: ['skinId'] },
            });
            return res && res.skinId === 'com.xunlei.plugin.skin.coolblack';
        }
        if (isPCNative) {
            let [_, res] = yield sendMessage({ platform: 'pc', name: 'GetSkinInfo' });
            try {
                res = JSON.parse(res);
                return res && res.colorID === 1;
            }
            catch (err) {
                console.info('PC isDark err', err);
            }
            return false;
        }
        return window.matchMedia('(prefers-color-scheme: dark)').matches;
    });
}
/**
 * 视图从原生页面回到webview页面注册的回调
 *
 * @export
 * @param {Function} cb
 */
export function viewWillAppear(cb) {
    if (isIOSNative) {
        window.WebViewJavascriptBridge.addEventListener('viewWillAppear', function () {
            cb && cb();
        });
    }
    else if (isAndroidNative) {
        // 此方法需要使用app协议在webview中打开才会生效，即 xunleiapp://xunlei.com/webview?from=xxx&url=xxx
        window.onResume = () => __awaiter(this, void 0, void 0, function* () {
            cb && cb();
        });
    }
}
/**
 * 获取迅雷当前是否版本是否为提审版本
 * 目前只支持Mac App store 提审版本
 */
export function getAppSVersion() {
    return __awaiter(this, void 0, void 0, function* () {
        if (isMacNative) {
            const [_, res] = yield sendMessage({ platform: 'mac', name: 'getAppSVersion' }, { callbackTimeout: 1000 * 300 });
            return res;
        }
    });
}
/**
 * 版本提审通过后，展示引导用户下载官网版本的弹窗
 * 目前只支持Mac App store 提审版本
 */
export function showNewVersionGuide() {
    if (isMacNative) {
        sendMessage({ platform: 'mac', name: 'showNewVersionGuide' }, { noCallback: true });
    }
}
/**
 * 显示会员弹窗
 */
export function showVipAlert(params) {
    const { aidfrom = '', type, extData = {} } = params;
    if (isIOSNative) {
        sendMessage({
            platform: 'ios',
            name: 'xlShowVipAlert',
            params: Object.assign({ aidfrom,
                type }, extData),
        }, { noCallback: true });
    }
}
/**
 * 跳转到系统设置页面（Android V8.10）
 */
export function gotoSystemPage(params) {
    if (isAndroidNative) {
        const page = params.page || 'app_detail';
        sendMessage({
            platform: 'android',
            name: 'xlGotoSystemPage',
            params: { page },
        }, { noCallback: true });
    }
}
//# sourceMappingURL=data:application/json;base64,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